export default __webpack_public_path__ + "img/af0404e6b59627efe2aa9ae7e1c1c2bd.png";